// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitchSlim_switch__SEmcM","slider":"ToggleSwitchSlim_slider__VN4Si","round":"ToggleSwitchSlim_round__PfOjk","iconColor":"ToggleSwitchSlim_iconColor__JLibg"};